/**
 * Take the first part of the UUID and convert it to uppercase. This makes it look nicer and
 * we save ourselves from creating a short identifier for a asset error.
 *
 * @param {string} id - The UUID of the asset error.
 */
export const formatAssetErrorId = (id?: string): string =>
  id?.split("-")[0]?.toUpperCase() ?? "-";
